import { Component, inject } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { routes } from '../../app.routes';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ArtIconComponent } from '../art-icon/art-icon.component';
import { sharedImports } from '../../sharedImports';
import { PermissionService } from '@services/permission.service';

@Component({
  selector: 'art-app-navigation',
  imports: [sharedImports, RouterLink, RouterLinkActive, ArtIconComponent],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
  providers: [provideTranslocoScope('navigation')],
})
export class NavigationComponent {
  private permissionService = inject(PermissionService);

  navigationRoutes = routes.filter(
    (route) =>
      route.path && ['home', 'stock', 'artist', 'sell-product', 'history', 'auction', 'settings'].includes(route.path),
  );

  filteredRoutes = this.permissionService.filterAuthorizedRoutes(this.navigationRoutes);

  itemIcons: Record<string, string> = {
    home: 'home',
    stock: 'inventory_2',
    artist: 'people',
    'sell-product': 'sell',
    history: 'confirmation_number',
    auction: 'balance',
    settings: 'settings',
  };
}
